import { HttpEvent, HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '../../environments/environment';
import { DealerService } from '../services';
import { isValidDealerId } from '../services/dealer-id';

const DEALER_ID_HEADER = 'x-dealer-id';

function isApiUrl(url: string): boolean {
  return url.startsWith(`${environment.apiUrl}/`);
}

/**
 * Adds the `x-dealer-id` header to every API request when a dealer-id is set on the
 * DealerService (sourced from the `?dealerId=` query param at app start).
 *
 * If no dealer-id is set, the header is intentionally omitted — app.ts gates the rest
 * of the app behind a "missing dealer-id" screen in that case, so requests outside that
 * gate should not occur in practice. Backend may eventually decide on a default; if so,
 * either set a default here or — preferably — keep the gate and let backend reject
 * missing-header requests explicitly.
 */
export const dealerIdInterceptor: HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn,
): Observable<HttpEvent<unknown>> => {
  if (!isApiUrl(req.url)) {
    return next(req);
  }

  const dealerId: string | null = inject(DealerService).currentDealerId();

  if (!dealerId || !isValidDealerId(dealerId)) {
    return next(req);
  }

  return next(
    req.clone({
      setHeaders: { [DEALER_ID_HEADER]: dealerId },
    }),
  );
};
